/**
 * Провизорные числа стартового баланса (D10–D12). Изолированы в одной точке,
 * чтобы их можно было заменить без изменения алгоритма initState.
 */
export const PROVISIONAL_START_HP = 30;
export const PROVISIONAL_START_ENERGY = 3;
export const PROVISIONAL_START_ENERGY_MAX = 3;
export const PROVISIONAL_START_HAND_SIZE = 5;
//# sourceMappingURL=defaults.js.map